// extracted by mini-css-extract-plugin
export default {"renameModal":"styles_renameModal__9-FfS","header":"styles_header__HgDih","title":"styles_title__nSo8l","inputField":"styles_inputField__Y209J","input":"styles_input__dgy42"};